// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-textfield {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, .55);
  border: 1px solid var(--text-secondary-color,rgba(0, 0, 0, .55));
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--background-color,rgba(255, 255, 255, 1));
  overflow: hidden;
  min-width: 64px;
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-textfield {
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-textfield {
  border: 2px solid rgba(0, 120, 212, 1);
  border: 2px solid var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-textfield-counter {
  align-self: end;
}
.bolt-textfield.disabled {
  color: rgba(0, 0, 0, .38);
  color: var(--text-disabled-color,rgba(0, 0, 0, .38));
  background-color: rgba( 244, 244, 244 ,  1 );
  background-color: rgba( var(--palette-neutral-4,244, 244, 244) ,  1 );
}
@media (forced-colors: active) {
  .bolt-textfield.disabled {
    color: graytext;
    background-color: window;
    forced-color-adjust: none;
    border: 1px solid graytext;
  }
  .bolt-textfield.disabled input {
    background-color: window;
  }
}
.bolt-textfield.focused.focus-treatment {
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--communication-background,rgba(0, 120, 212, 1));
  animation: ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-textfield.focused.focus-treatment {
    animation: none;
  }
}
.bolt-textfield.focused.focus-treatment {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23), 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
}
@media (forced-colors: active) {
  .bolt-textfield.focused.focus-treatment {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-textfield.focused.focus-treatment {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-textfield.focused.focus-treatment {
    color: windowtext;
    background-color: window;
  }
}
@media (forced-colors: active) {
  .bolt-textfield.focused.focus-treatment > * {
    forced-color-adjust: auto;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-textfield.focused.focus-treatment {
  outline: 2px solid rgba(0, 90, 158, 1);
  outline: 2px solid var(--communication-foreground,rgba(0, 90, 158, 1));
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-textfield.focused.focus-treatment {
  outline: 2px solid rgba(0, 90, 158, 1);
  outline: 2px solid var(--communication-foreground,rgba(0, 90, 158, 1));
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-textfield.focused {
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--communication-background,rgba(0, 120, 212, 1));
  animation: ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-textfield.focused {
    animation: none;
  }
}
.bolt-textfield.focused {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23), 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
}
@media (forced-colors: active) {
  .bolt-textfield.focused {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-textfield.focused {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-textfield.focused {
    color: windowtext;
    background-color: window;
  }
}
@media (forced-colors: active) {
  .bolt-textfield.focused > * {
    forced-color-adjust: auto;
  }
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-textfield.focused {
  outline: 2px solid rgba(0, 90, 158, 1);
  outline: 2px solid var(--communication-foreground,rgba(0, 90, 158, 1));
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--focus-border-color,rgba(0, 120, 212, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-textfield.focused {
  outline: 2px solid rgba(0, 90, 158, 1);
  outline: 2px solid var(--communication-foreground,rgba(0, 90, 158, 1));
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--focus-border-color,rgba(0, 120, 212, 1));
}
.bolt-textfield .prefix {
  padding-left: 4px;
  margin-left: 7px;
}
.bolt-textfield .suffix {
  padding-right: 4px;
  margin-right: 7px;
}

.subtle.bolt-textfield:not(.focused):not(.disabled) {
  background-color: inherit;
}

.hide-border.bolt-textfield:not(.focused):not(:hover) {
  border-color: transparent;
}

.bolt-textfield-error.bolt-textfield,
.bolt-textfield-error .bolt-textfield {
  border-color: rgba(218, 10, 0, 1);
  border-color: var(--status-error-text,rgba(218, 10, 0, 1));
}

.bolt-textfield-warning.bolt-textfield {
  border-color: rgba(184, 94, 6, 1);
  border-color: var(--status-warning-text,rgba(184, 94, 6, 1));
}

.bolt-textfield-auto-adjust {
  overflow: hidden;
}

.bolt-textfield-auto-adjust-hidden {
  position: absolute;
  visibility: hidden;
  width: 100%;
}

.bolt-textfield-auto-unresizable {
  resize: none;
}

.bolt-textfield-input {
  border: none;
  outline: none;
  background-color: inherit;
  padding: 5px 11px;
  resize: none;
}
.bolt-textfield-input::placeholder {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.bolt-textfield-input:-ms-input-placeholder {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.bolt-textfield-input::-ms-input-placeholder {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.bolt-textfield-input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
.bolt-textfield-input:-moz-placeholder {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-textfield-input::placeholder {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-textfield-input::placeholder {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
.bolt-textfield-input::-ms-clear {
  display: none;
}
.bolt-textfield-input:-moz-ui-invalid {
  box-shadow: none;
}
.bolt-textfield-input.activatable {
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.bolt-textfield-input.activatable::-moz-selection {
  background: transparent;
}
.bolt-textfield-input.activatable::selection {
  background: transparent;
}

.bolt-textfield-input-with-prefix {
  padding-left: 8px;
}

.bolt-textfield-input-with-suffix {
  padding-right: 8px;
}

.bolt-textfield-no-text {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}

.bolt-textfield-message {
  margin-top: 8px;
  font-size: 0.75rem;
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}

.bolt-textfield-message-error {
  color: rgba(218, 10, 0, 1);
  color: var(--status-error-text,rgba(218, 10, 0, 1));
}

.bolt-textfield-message-warning {
  color: rgba(184, 94, 6, 1);
  color: var(--status-warning-text,rgba(184, 94, 6, 1));
}

.bolt-textfield-label {
  margin-bottom: 8px;
}
.bolt-textfield-label--required::after {
  content: " *";
  color: rgba(218, 10, 0, 1);
  color: var(--status-error-text,rgba(218, 10, 0, 1));
}

.bolt-text-filterbaritem {
  background-color: transparent;
  border: none;
}

.bolt-text-filterbaritem-input {
  background-color: transparent;
  text-overflow: ellipsis;
  position: relative;
}
.bolt-text-filterbaritem-input::placeholder {
  color: rgba(0, 0, 0, 0.60);
  color: var(--palette-black-alpha-60,rgba(0, 0, 0, 0.60));
}
.bolt-text-filterbaritem-input:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.60);
  color: var(--palette-black-alpha-60,rgba(0, 0, 0, 0.60));
}
.bolt-text-filterbaritem-input::-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.60);
  color: var(--palette-black-alpha-60,rgba(0, 0, 0, 0.60));
}
.bolt-text-filterbaritem-input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.60);
  color: var(--palette-black-alpha-60,rgba(0, 0, 0, 0.60));
}
.bolt-text-filterbaritem-input:-moz-placeholder {
  color: rgba(0, 0, 0, 0.60);
  color: var(--palette-black-alpha-60,rgba(0, 0, 0, 0.60));
}

.bolt-text-filterbaritem-clear.bolt-button:not(:hover) {
  background-color: transparent;
}
.bolt-text-filterbaritem-clear.bolt-button.icon-only {
  padding: 4px;
  font-size: 1rem;
  border-color: transparent;
}

.bolt-focus-visible .bolt-text-filterbaritem-clear.bolt-button.bolt-focus-treatment:focus {
  animation: none;
  box-shadow: none;
  background-color: rgba(0, 0, 0, 0.10);
  background-color: var(--palette-black-alpha-10,rgba(0, 0, 0, 0.10));
}

.bolt-textfield-inline {
  background-color: rgba(0, 0, 0, 0.06);
  background-color: var(--palette-black-alpha-6,rgba(0, 0, 0, 0.06));
}
.bolt-textfield-inline:not(.disabled) {
  border-color: transparent;
}
.bolt-textfield-inline .bolt-textfield-input {
  background-color: transparent;
}
.bolt-textfield-inline:hover:not(.disabled):not(.focused) {
  background-color: rgba(0, 0, 0, 0.10);
  background-color: var(--palette-black-alpha-10,rgba(0, 0, 0, 0.10));
}

.bolt-textfield-inline:hover:not(.disabled) {
  cursor: text;
}

.bolt-textfield-default-width {
  width: 296px;
}

.bolt-textfield-inline-tabbar-width {
  width: 244px;
}

@media screen and (max-width: 599px) {
  .bolt-inline-keyword-filter-bar {
    flex-grow: 1;
    margin-top: 16px;
  }
}

.bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only {
  border-color: rgba(0, 120, 212, 1);
  border-color: var(--communication-background,rgba(0, 120, 212, 1));
  animation: ms-focus-shadow-with-border-pulse 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only {
    animation: none;
  }
}
.bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only {
  box-shadow: 0 0 0 3px rgba(0, 120, 212, 0.23), 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only {
    forced-color-adjust: none;
    border-color: highlight;
  }
}
@media screen and (forced-colors: active) and (prefers-color-scheme: light) {
  .bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only {
    outline: 1px solid highlight;
    outline-offset: 1px;
  }
}
@media (forced-colors: active) {
  .bolt-focus-visible .bolt-textfield.focused.focus-keyboard-only {
    background: window;
    color: windowtext;
  }
}

/*# sourceMappingURL=TextField.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/TextField/TextField.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/TextField/TextField.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AAKA;EACI,wBCuJW;EDtJX,kDAAA;EACA,kBAAA;EACA,oCCgJc;ED/Id,gEAAA;EACA,wCAAA;EEJF,gEAAgE;ED+X1D,gBAAA;EDxXA,eAAA;AEJR;AD+XQ;ED3XA,sCAAA;EEDN,gEAAgE;AFI9D;AEFJ;EACE,sCAAsC;EFKpC,gEAAA;AEHJ;AACA;EACE,eAAe;AC2Bb;ADzBJ;EACE,yBFGU;EEFV,oDFGU;EEFV,4CFGU;EEFV,qEFGU;AEFZ;AACA;EACE;IACE,eAAe;IACf,wBAAwB;IFMxB,yBAAA;IACI,0BCdmB;EEgCnB;EDrBN;ICYE,wBAAA;EHVA;AECJ;AACA;EACE,kCAAkC;EFHhC,kEAAA;EG+BI,oEAAA;ADzBR;ACII;EHVA;IG+CI,eAAA;EDrCN;AACF;AACA;ECuCI,6EAAA;EHnDA,oIAAA;AEeJ;AACA;EACE;IACE,yBAAyB;ICRzB,uBAAA;EHVA;AEqBJ;AACA;EACE;IACE,4BAA4B;ICd5B,mBAAA;EHFI;AEmBR;AACA;EACE;IDoUM,iBAAA;IDnVI,wBAAA;EACA;AEkBZ;ADmUQ;EDtVI;IACA,yBGjDS;EDuEnB;AFlBE;AEoBJ;ECpBQ,sCAAA;EDsBN,sEAAsE;EC/BpE,kCAAA;EHSA,4DAAA;AEyBJ;AACA;EACE,sCAAsC;EF3BpC,sEAAA;EGYI,kCAAA;EDkBN,4DAA4D;ACvC1D;ADyCJ;EACE,kCCLM;EDMN,kECLM;EDMN,oEAAoE;AACtE;ACJI;EHhCA;IGiCI,eAAA;EDON;AACF;AACA;ECnDI,6EAAA;EHSA,oIAAA;AE6CJ;AACA;EACE;IACE,yBAAyB;ICzDzB,uBAAA;EHkBI;AE0CR;AACA;EACE;IDyRM,4BAAA;ID/TI,mBAAA;EACA;AEyCZ;ADwRQ;EDlUI;IACA,iBGrES;IDkHjB,wBAAwB;EFzCxB;AE2CJ;AACA;EACE;IFxCE,yBAAA;EACI;AE0CR;AACA;EACE,sCAAsC;EFpCpC,sEAAA;EACI,kCAAA;EEsCN,4DAA4D;AAC9D;AFhCI;EACI,sCAAA;EEkCN,sEAAsE;EACtE,kCAAkC;EF5BpC,4DAAA;AAAA;AE+BA;EACE,iBAAiB;EACjB,gBAAgB;AF5BlB;AE8BA;EACE,kBAAkB;EAClB,iBAAiB;AF5BnB;;AE+BA;EACE,yBAAyB;AF5B3B;;AE+BA;EF5BI,yBAAA;AE8BJ;;AF3BA;;EE+BE,iCAAiC;EACjC,0DAA0D;AF5B5D;;AE+BA;EF5BI,iCAAA;EACA,4DAAA;AE8BJ;;AFxBI;EACI,gBCqBS;ACMjB;;AAEA;EACE,kBAAkB;EFzBhB,kBAAA;EACI,WCeS;ACYjB;;AAEA;EACE,YAAY;AFzBV;;AE4BJ;EFvBQ,YAAA;EACI,aAAA;EEyBV,yBAAyB;EF1BnB,iBAAA;EACI,YAAA;AE4BZ;AFxBI;EACI,yBAAA;EE0BN,qDAAqD;AFvBnD;AEyBJ;EACE,yBAAyB;EFtBvB,qDAAA;AEwBJ;AACA;EFrBQ,yBAAA;EACA,qDAAA;AEuBR;AACA;EFrBQ,yBAAA;EEuBN,qDAAqD;AFrB/C;AEuBR;EACE,yBAAyB;EFrBnB,qDAAA;AEuBR;AACA;EACE,wBAAwB;EFnB1B,kDAAA;AEqBA;AACA;EACE,wBAAwB;EFnB1B,kDAAA;AEqBA;AACA;EACE,aAAa;AFnBf;AEqBA;EACE,gBAAgB;AAClB;AFnBA;EACI,eC4GQ;ED3GR,2BCgEO;ED/DP,yBC1Ca;EC+Df,wBAAwB;EACxB,sBAAsB;EFnBxB,qBAAA;EACI,iBCuCS;AClBb;AACA;EFnBA,uBAAA;AEqBA;AACA;EACE,uBAAuB;AFnBzB;;AEsBA;EFpBI,iBAAA;AEsBJ;;AAEA;EACE,kBAAkB;AFnBpB;;AEsBA;EACE,yBAAyB;EACzB,qDAAqD;AFnBvD;;AEsBA;EFnBI,eAAA;EEqBF,kBAAkB;EFhBhB,yBAAA;EACI,qDC/HW;ACiJnB;;AAEA;EACE,0BAA0B;EFhBxB,mDAAA;AEkBJ;;AFfI;EACI,0BCxIW;EC0JjB,qDAAqD;AFhBnD;;AEmBJ;EACE,kBAAkB;AFdhB;AEgBJ;EACE,aAAa;EFbX,0BAAA;EACI,mDAAA;AEeR;;AAEA;EACE,6BAA6B;EFZ/B,YAAA;AEcA;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EFZzB,kBAAA;AEcA;AACA;EFZI,0BAAA;EACI,wDAAA;AEcR;AFXI;EACI,0BAAA;EEaN,wDAAwD;AFVtD;AEYJ;EACE,0BAA0B;EAC1B,wDAAwD;AFT1D;AEWA;EACE,0BAA0B;EAC1B,wDAAwD;AFT1D;AEWA;EACE,0BAA0B;EAC1B,wDAAwD;AFT1D;;AEYA;EACE,6BAA6B;AD6C3B;AC3CJ;EACE,YFTM;EEUN,eDMW;ECLX,yBAAyB;AAC3B;;AFPA;EACI,eC3RuB;EEgCnB,gBAAA;EDsQN,qCAAqC;EC/QnC,mEAAA;ADiRJ;;AAEA;EACE,qCAAqC;EFjBvC,kEAAA;AEmBA;AACA;ECvRI,yBAAA;ADyRJ;AACA;EACE,6BCrPM;ADsPR;AACA;ECpPI,qCAAA;EH0NJ,mEAAA;AE6BA;;AAEA;EACE,YAAY;ACnSV;;ADsSJ;EACE,YF9BM;AE+BR;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,kCAAkC;EAClC,kEAAkE;EAClE,oEAAoE;AACtE;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,6EAA6E;EAC7E,oIAAoI;AACtI;AACA;EACE;IACE,yBAAyB;IACzB,uBAAuB;EACzB;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,mBAAmB;EACrB;AACF;AACA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF;;AAEA,wCAAwC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
